import {
  FETCH_VIEW_COURSE_DETAILS_REQUEST,
  FETCH_VIEW_COURSE_DETAILS_SUCCESS,
  FETCH_VIEW_COURSE_DETAILS_FAILURE,
} from "./view-course.action";

const initialState = {
    viewCourseDefinitionDetails: null,
    table: { data: [] },
    loading: false,
    error: null,
};

export const viewCourseReducer = (state = initialState, action: any) => {
  switch (action.type) {
          case FETCH_VIEW_COURSE_DETAILS_REQUEST:
              return { ...state, loading: true, error: null, courseDefintionID: action.payload?.courseDefintionID };
          case FETCH_VIEW_COURSE_DETAILS_SUCCESS:
              return { ...state, loading: false, viewCourseDefinitionDetails: action.payload, error: null };
          case FETCH_VIEW_COURSE_DETAILS_FAILURE:
              return { ...state, loading: false, error: action.payload, viewCourseDefinitionDetails: null };
          default:
              return state;
      }
};

export default viewCourseReducer;
